import { memo } from 'react';

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path fill="#637381" d="M9.5 12c-2.302 0-4.167-2.7-4.167-5v-.833a4.167 4.167 0 018.333 0V7c0 2.3-1.866 5-4.167 5z" opacity="0.32" />
      <g clipPath="url(#clip0_513_3503)">
        <path
          fill="#637381"
          d="M20.697 17.605c.034-.2.052-.402.053-.605a3.768 3.768 0 00-.053-.605l.875-.846a.418.418 0 00.07-.507l-.624-1.084a.42.42 0 00-.476-.192l-1.167.334a3.757 3.757 0 00-1.053-.605l-.293-1.18a.417.417 0 00-.404-.315h-1.25a.416.416 0 00-.404.316l-.295 1.179c-.38.143-.736.348-1.051.605l-1.167-.334a.421.421 0 00-.476.192l-.625 1.084a.416.416 0 00.071.508l.875.845c-.034.2-.052.402-.053.605.001.203.02.405.053.605l-.875.846a.417.417 0 00-.07.507l.624 1.084a.417.417 0 00.476.192l1.167-.333c.316.257.671.461 1.053.604l.294 1.18a.417.417 0 00.403.315h1.25a.416.416 0 00.404-.316l.295-1.179a3.76 3.76 0 001.051-.605l1.167.334a.417.417 0 00.476-.192l.625-1.084a.417.417 0 00-.072-.508l-.874-.845zM17 18.667a1.667 1.667 0 110-3.334 1.667 1.667 0 010 3.334z"
        />
      </g>
      <path
        fill="#637381"
        d="M10.333 17c0-1.18.31-2.284.846-3.245a16.32 16.32 0 00-1.679-.088c-2.353 0-4.44.531-5.812.994A2.492 2.492 0 002 17.027v3.306h9.232A6.63 6.63 0 0110.334 17z"
        opacity="0.32"
      />
      <defs>
        <clipPath id="clip0_513_3503">
          <path fill="#fff" d="M0 0H10V10H0z" transform="translate(12 12)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(Icon);
